<div class="formHintText" @demoAnimation>
  {{ "page.login.form.forgotUserId.info" | translate }}
</div>
<form @demoAnimation  
[formGroup]="userIDForm">
  <mat-form-field class="w-full" appearance="fill">
    <mat-label>{{ "page.login.form.forgotUserId.emailField.label" | translate }}</mat-label>
    <input
      matInput
      id="txtForgotUsername"
      type="email"
      name="userID"
      formControlName="Email"
      placeholder="{{ 'page.login.form.forgotUserId.emailField.label' | translate }}"
     (blur)="userIDForm.get('Email')?.markAsTouched()"
    />
   <mat-error *ngIf="userIDForm.get('Email')?.hasError('required') && userIDForm.get('Email')?.touched">
    {{ 'page.login.form.forgotUserId.emailField.required' | translate }}
  </mat-error>
  <mat-error *ngIf="userIDForm.get('Email')?.errors?.['maxlength']">
    {{ 'page.login.form.forgotUserId.emailField.EmailMaxErr' | translate }}  
  </mat-error>
    <mat-error *ngIf="userIDForm.get('Email')?.hasError('email') && !userIDForm.get('Email')?.hasError('required')  ">
      {{ "page.login.form.forgotUserId.emailField.invalidMail" | translate }}
    </mat-error>
    <mat-error *ngIf="userIDForm.get('Email')?.hasError('serverError')">
      {{ userIDForm.get('Email')?.getError('serverError') }}
    </mat-error>
  </mat-form-field>
  
  <div class="BtnWrapper">
    <button type="submit"
      id="btlForgotPwd"
      kendoButton
      color="primary"
      name="recover-password-button"
      [disabled]="!userIDForm.valid"
      (click)="recoverUserId()"
    >
      {{ "page.login.form.forgotUserId.emailField.submit" | translate }}
    </button>
  </div>  
</form>